"use client"; // Indicate this is a client component

import { useEffect } from "react";
import PageLayout from "@/components/_shared/PageLayout";
import TOTPForm from "@/components/totp-generator/TOTPForm";

// Define the specific instructions for this page

export default function TOTPPage() {
	useEffect(() => {
		document.title = "TOTP Generator";
	}, []);

	return (
		<PageLayout
			additionalItemsToDelete={["totp_pinned"]}
			confirmationText="Willst du wirklich alle TOTP-Daten löschen? Dies wird alle Einstellungen und angehefteten Codes zurücksetzen und kann nicht rückgängig gemacht werden."
			title="TOTP Generator"
			toolId="totp"
		>
			<main className="grid grid-cols-1 gap-6">
				<TOTPForm initialCode={""} />{" "}
				{/* Initial code from URL needs param handling */}
			</main>
		</PageLayout>
	);
}
